import { render, staticRenderFns } from "./MediumPost.vue?vue&type=template&id=052e2b46&scoped=true&"
import script from "./MediumPost.vue?vue&type=script&lang=ts&"
export * from "./MediumPost.vue?vue&type=script&lang=ts&"
import style0 from "./MediumPost.vue?vue&type=style&index=0&id=052e2b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e2b46",
  null
  
)

export default component.exports